export const SEARCH_NS = 'search';